<template>
  <svg
    class="animate-spin"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    style="
      margin-right: -2px;
      display: block;
      background-repeat-y: initial;
      background-repeat-x: initial;
      animation-play-state: paused;
    "
  >
    <g
      transform="translate(80,50)"
      style="
        transform: matrix(1, 0, 0, 1, 80, 50);
        animation-play-state: paused;
      "
    >
      <g
        transform="rotate(0)"
        style="
          transform: matrix(1, 0, 0, 1, 0, 0);
          animation-play-state: paused;
        "
      >
        <circle
          cx="0"
          cy="0"
          r="6"
          fill="#b3c430"
          fill-opacity="0.125"
          transform="matrix(1.0625,0,0,1.0625,0,0)"
          style="
            transform: matrix(1.0625, 0, 0, 1.0625, 0, 0);
            animation-play-state: paused;
          "
        ></circle>
      </g>
    </g>
    <g
      transform="translate(71.21320343559643,71.21320343559643)"
      style="
        transform: matrix(1, 0, 0, 1, 71.2132, 71.2132);
        animation-play-state: paused;
      "
    >
      <g
        transform="rotate(45)"
        style="
          transform: matrix(0.707107, 0.707107, -0.707107, 0.707107, 0, 0);
          animation-play-state: paused;
        "
      >
        <circle
          cx="0"
          cy="0"
          r="6"
          fill="#b3c430"
          fill-opacity="0.25"
          transform="matrix(1.125,0,0,1.125,0,0)"
          style="
            transform: matrix(1.125, 0, 0, 1.125, 0, 0);
            animation-play-state: paused;
          "
        ></circle>
      </g>
    </g>
    <g
      transform="translate(50,80)"
      style="
        transform: matrix(1, 0, 0, 1, 50, 80);
        animation-play-state: paused;
      "
    >
      <g
        transform="rotate(90)"
        style="
          transform: matrix(6.12323e-17, 1, -1, 6.12323e-17, 0, 0);
          animation-play-state: paused;
        "
      >
        <circle
          cx="0"
          cy="0"
          r="6"
          fill="#b3c430"
          fill-opacity="0.375"
          transform="matrix(1.1875,0,0,1.1875,0,0)"
          style="
            transform: matrix(1.1875, 0, 0, 1.1875, 0, 0);
            animation-play-state: paused;
          "
        ></circle>
      </g>
    </g>
    <g
      transform="translate(28.786796564403577,71.21320343559643)"
      style="
        transform: matrix(1, 0, 0, 1, 28.7868, 71.2132);
        animation-play-state: paused;
      "
    >
      <g
        transform="rotate(135)"
        style="
          transform: matrix(-0.707107, 0.707107, -0.707107, -0.707107, 0, 0);
          animation-play-state: paused;
        "
      >
        <circle
          cx="0"
          cy="0"
          r="6"
          fill="#b3c430"
          fill-opacity="0.5"
          transform="matrix(1.25,0,0,1.25,0,0)"
          style="
            transform: matrix(1.25, 0, 0, 1.25, 0, 0);
            animation-play-state: paused;
          "
        ></circle>
      </g>
    </g>
    <g
      transform="translate(20,50.00000000000001)"
      style="
        transform: matrix(1, 0, 0, 1, 20, 50);
        animation-play-state: paused;
      "
    >
      <g
        transform="rotate(180)"
        style="
          transform: matrix(-1, 1.22465e-16, -1.22465e-16, -1, 0, 0);
          animation-play-state: paused;
        "
      >
        <circle
          cx="0"
          cy="0"
          r="6"
          fill="#b3c430"
          fill-opacity="0.625"
          transform="matrix(1.3125,0,0,1.3125,0,0)"
          style="
            transform: matrix(1.3125, 0, 0, 1.3125, 0, 0);
            animation-play-state: paused;
          "
        ></circle>
      </g>
    </g>
    <g
      transform="translate(28.78679656440357,28.786796564403577)"
      style="
        transform: matrix(1, 0, 0, 1, 28.7868, 28.7868);
        animation-play-state: paused;
      "
    >
      <g
        transform="rotate(225)"
        style="
          transform: matrix(-0.707107, -0.707107, 0.707107, -0.707107, 0, 0);
          animation-play-state: paused;
        "
      >
        <circle
          cx="0"
          cy="0"
          r="6"
          fill="#b3c430"
          fill-opacity="0.75"
          transform="matrix(1.375,0,0,1.375,0,0)"
          style="
            transform: matrix(1.375, 0, 0, 1.375, 0, 0);
            animation-play-state: paused;
          "
        ></circle>
      </g>
    </g>
    <g
      transform="translate(49.99999999999999,20)"
      style="
        transform: matrix(1, 0, 0, 1, 50, 20);
        animation-play-state: paused;
      "
    >
      <g
        transform="rotate(270)"
        style="
          transform: matrix(-1.83697e-16, -1, 1, -1.83697e-16, 0, 0);
          animation-play-state: paused;
        "
      >
        <circle
          cx="0"
          cy="0"
          r="6"
          fill="#b3c430"
          fill-opacity="0.875"
          transform="matrix(1.4375,0,0,1.4375,0,0)"
          style="
            transform: matrix(1.4375, 0, 0, 1.4375, 0, 0);
            animation-play-state: paused;
          "
        ></circle>
      </g>
    </g>
    <g
      transform="translate(71.21320343559643,28.78679656440357)"
      style="
        transform: matrix(1, 0, 0, 1, 71.2132, 28.7868);
        animation-play-state: paused;
      "
    >
      <g
        transform="rotate(315)"
        style="
          transform: matrix(0.707107, -0.707107, 0.707107, 0.707107, 0, 0);
          animation-play-state: paused;
        "
      >
        <circle
          cx="0"
          cy="0"
          r="6"
          fill="#b3c430"
          fill-opacity="1"
          transform="matrix(1.5,0,0,1.5,0,0)"
          style="
            transform: matrix(1.5, 0, 0, 1.5, 0, 0);
            animation-play-state: paused;
          "
        ></circle>
      </g>
    </g>
    <!-- generated by https://loading.io/ -->
  </svg>
</template>

<script>
export default {
  name: 'spinLoading',
  props: {
    size: {
      type: String,
      default: '30px',
    },
  },
};
</script>
